import { render, staticRenderFns } from "./DiscardItemDialog.vue?vue&type=template&id=94ee14ac&"
import script from "./DiscardItemDialog.ts?vue&type=script&lang=ts&"
export * from "./DiscardItemDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports